/**
 * Helper function to log out events to the console for debugging purposes.
 *
 * @param name The name of the event.
 * @param args The arguments of the event.
 */
export function log(name: string, args?: unknown) {
  if (import.meta.client && import.meta.dev) {
    console.log(
      `%c🎯 tracking%c${name}`,
      'color: #B4E0FF; background: #032e5a; margin: 0 2px; padding: 2px 6px; border-radius: 4px;',
      'color: #032e5a; background: #B4E0FF; margin: 0 2px; padding: 2px 6px; border-radius: 4px;',
      args,
    )
  }
}

/**
 * Helper function to log out errors to the console for debugging purposes.
 *
 * @param name The name of the event.
 * @param violations The violation that triggered the event.
 * @param payload The payload that caused the event.
 */
export function logViolation(name: string, violations: string, payload?: unknown) {
  if (import.meta.client && import.meta.dev) {
    console.error(
      `%c🎯 tracking%c${name}%c violates tracking plan\n${violations}`,
      'color: #FFD6D6; background: #7a0010; margin: 0 2px; padding: 2px 6px; border-radius: 4px;',
      'color: #7a0010; background: #FFD6D6; margin: 0 2px; padding: 2px 6px; border-radius: 4px;',
      'color: #7a0010; font-weight: bold;',
      payload,
    )
  }
}
